<script lang="ts" setup>
import useMainStore from '~/shared/store'
import Spinner from '~/components/ui/preloader/Spinner.vue'
import { useMonitorSize } from '~/composables/monitor-size'
import type { IMonitorSize } from '~/shared/interfaces/composables'
import type {IBanner} from '~/shared/interfaces/banners'

interface RandomBanner {
  target_blank: boolean;
  desktopImage: string;
  mobileImage?: string;
  link: string;
}

const props = defineProps<{
  apiEndpoint: string;
}>();

let sizes: IMonitorSize | null = useMonitorSize();
const mainStore = useMainStore();
const route = useRoute();
const banner = ref<RandomBanner | null>(null);

async function getRandomBanner() {
  let start = performance.now()

  if (!mainStore.banners.length) {
    const { data: banners } = await useFetch(
      `/api/banners/${props.apiEndpoint}`
    );

    if (banners.value) {
      mainStore.setBanners(banners.value);
    }
  }

  let randBanner: IBanner = mainStore.banners[getRandomInt(mainStore.banners.length - 1)];
  let end = performance.now()
  const time = (end - start) / 1000
  if (randBanner) {
    return {
      target_blank: randBanner.target_blank,
      desktopImage: randBanner?.image,
      mobileImage: randBanner?.mobile_image,
      link: randBanner?.link,
    };
  }
  return null;
}

function getRandomInt(max: number) {
  const min = 0;
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

watch(
   () => route.fullPath,
   async () => {
     await nextTick();
     banner.value = await getRandomBanner();
   }
);

onMounted(async () => {
  banner.value = await getRandomBanner();
});

await getRandomBanner()

</script>

<template>
  <div
    class="slider-spinner container"
    v-if="!banner"
  >
    <div class="slider-spinner__container">
      <Spinner/>
    </div>
  </div>
  <ClientOnly v-else>
    <div class="banner container">
      <NuxtLink :to="banner?.link" :target="banner?.target_blank ? '_blank' : '_self'" class="banner__image">
        <nuxt-img
          :src="sizes.isMobile ? banner?.mobileImage : banner?.desktopImage"
          alt=""
          loading="lazy"
          width="1296"
          height="160"
          fit="fill"
        />
      </NuxtLink>
    </div>
  </ClientOnly>
</template>

<style lang="scss" scoped>
.slider-spinner {
  height: 184px;
  width: 100%;
  border-radius: 20px;
  padding: 24px 28px 0;

  @include md-breakpoint {
    padding: 24px 20px 20px;
    height: 185px;
  }
  @include screen(420) {
    height: 154px;
  }

  &__container {
    background-color: $control-bg_neutral;
    width: 100%;
    height: 100%;
    border-radius: 20px;

    .spinner-container {
      background-color: transparent;
    }
  }
}
.banner {
  padding: 24px 28px 0;
  @include md-breakpoint {
    padding: 20px;
    background-color: $bg_page;
  }

  &__image {
    max-height: 160px;
    overflow: hidden;
    border-radius: 16px;
    @include md-breakpoint {
      max-height: none;
    }

    img {
      width: 100%;
      height: 100%;
      object-position: center;
    }
  }
}
</style>
